import { useEffect, useSyncExternalStore } from "react";
import type { Locale } from "@/lib/i18n/locales";
import {
  catalogTextRevision,
  loadCatalogText,
  subscribeCatalogText,
} from "@/lib/i18n/catalog-text";

/** Subscribe where catalog text is rendered, including memoized canvas nodes. */
export function useCatalogText(locale: Locale, enabled = true): number {
  const revision = useSyncExternalStore(subscribeCatalogText, catalogTextRevision, catalogTextRevision);
  useEffect(() => {
    if (enabled) void loadCatalogText(locale).catch(() => {
      // Keep the canonical labels usable offline; a later mount can retry.
    });
  }, [locale, enabled]);
  return revision;
}
